// Vite's import.meta.env.BASE_URL always has a trailing slash ('/' by
// default); CRA's process.env.PUBLIC_URL was '' (no "homepage" configured).
// Strip the trailing slash so existing `PUBLIC_URL + "/path"` call sites
// keep producing a single leading slash instead of a protocol-relative "//path".
export const PUBLIC_URL = import.meta.env.BASE_URL.replace(/\/$/, '');
